import { LoadingKey } from '../app-active-loading/LoadingKey';
import { isCopyCarouselFinished, isLoadingKeyActive } from '../store/loading-status/selectors';
export const getCopyCarouselFinishedInACQ143Variant = state => {
  const isACQ143VariantLoadingAndCarouselFinsihed = isLoadingKeyActive(state, LoadingKey.ACQ143PortalCreated) ? isCopyCarouselFinished(state, LoadingKey.ACQ143PortalCreated) : true;
  return isACQ143VariantLoadingAndCarouselFinsihed;
};